module.exports = __webpack_public_path__ + "static/img/hot.b95662e7.jpg";